import React, { useEffect, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../../lib/ep';
import { useCSS } from '../../../lib/hooks';

import ActionLink from '../../builder/ActionLink';
import { localizeFields } from '../../builder/DynamicFields';

import ConfettiCanvas from '../../games/ConfettiCanvas';
import { formatTokenTitle } from './TokenAmount';

import LeveledHTMLText from '../helpers/LeveledHTMLText';

const EarnedPointsMessage = (props) => {
	useCSS('comp/prize_gallery.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const confetti_canvas = useRef();
	const use_confetti = false;

	const promotion = props?.promotion?.Promotion ?? false;

	const has_shop_enabled = promotion?.loyalty_shop_enabled ?? false;
	const display_link = ((has_shop_enabled) && (promotion?.loyalty_display_shop_link ?? true)) ? true : false;

	const is_builder = props?.is_builder ?? false;
	const text_placeholder = `<h2>${i18n("You've won {num_coins} {coin_name}")}</h2><p>${i18n("You have {total_coins} {total_coin_name} in total")}</p>`;
	const raw_message = (isNotEmpty(promotion, 'loyalty_display_shop_text')) ? promotion.loyalty_display_shop_text : text_placeholder;

	let token = props?.loyalty?.token?.LoyaltyToken ?? {};
	[token] = localizeFields([token],props.locale);

	let num_coins = parseInt(props?.loyalty?.amount ?? 0);
	if(is_builder) num_coins = 58;

	let total_coins = parseInt(props?.loyalty?.total ?? 0);
	if(is_builder) total_coins = 241;

	const replaces = {
		num_coins,
		total_coins,
		coin_name:formatTokenTitle(token, num_coins),
		total_coin_name:formatTokenTitle(token, total_coins),
		coin_icon:(isNotEmpty(token, 'full_image')) ? `<img class="token_img" src="${token.full_image}" alt="" />` : null,
	};

	useEffect(() => {
		if(!use_confetti) return;

		confetti_canvas.current.play_animation();
	}, []);

	if(num_coins == 0) return null;

	return (
		<div class="gui_loyalty_message">
			{(use_confetti) && (
				<ConfettiCanvas
					ref={confetti_canvas}
					canvas_size_w={300}
					canvas_size_h={300}
				/>
			)}

			<LeveledHTMLText>
				{props.intl.formatMessage({ id:raw_message }, replaces)}
			</LeveledHTMLText>

			{(display_link) && (
				<ActionLink
					_href={(!is_builder) ? `/loyalty/prize_gallery/${promotion.id}` : null}
					autotranslate={false}
				>{props.intl.formatMessage({ id:"Redeem your {total_coin_name}" }, replaces )}</ActionLink>
			)}
		</div>
	)
};

export default injectIntl(EarnedPointsMessage);